<template>
    <div class="page">
        <div class="page__bd">
            <div class="form-preview weui-form-preview">
                <div class="weui-form-preview__hd">
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">客户编号</label>
                        <em class="weui-form-preview__value">{{ form.main.ctc_cucode }}</em>
                    </div>
                </div>
                <div class="weui-form-preview__bd">
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">客户名称</label>
                        <em class="weui-form-preview__value">{{ form.main.ctc_cuname }}</em>
                    </div>
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">客户类型</label>
                        <span class="weui-form-preview__value">{{ form.main.cu_type }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.main.cu_sellername">
                        <label class="weui-form-preview__label">业务员</label>
                        <span class="weui-form-preview__value weui-form-preview__value-icon">{{ form.main.cu_sellername }}
                            <call-mobile :em-id="form.main.cu_sellerid"></call-mobile>
                        </span>
                    </div>
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">应收余额(元)</label>
                        <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{ form.main.cu_leftamount }}</span>
                    </div>
                </div>
            </div>

            <div class="form-preview weui-form-preview">
                <div class="weui-form-preview__bd form-detail-preview">
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">信用额度</label>
                        <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{ form.main.ctc_credit }}</span>
                    </div>
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">临时信用额度</label>
                        <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{ form.main.ctc_credit_temp }}</span>
                    </div>
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">总信用额度</label>
                        <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{ form.main.ctc_credit_sum }}</span>
                    </div>
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">截止日期</label>
                        <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{ form.main.ctc_enddate }}</span>
                    </div>
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">申请原因</label>
                        <span class="weui-form-preview__value">{{ form.main.ctc_remark }}</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import form from "@/mixins/form.js";
import CallMobile from "@/components/button/CallMobile.vue";

export default {
    mixins: [form],
    components: {
        CallMobile
    },
    data() {
        return {
            baseUrl: "/api/document/customertempcredit"
        };
    }
};
</script>